import { AUTH } from 'store/actions/types'
import Webphone from 'common/Webphone'
import Api from 'common/Api'
import EventEmitter from 'common/EventEmitter'
import { Events, TabIdCookieName } from 'common/Enums'
import Cookies from 'js-cookie'

function signInHandler(apiPromise, dispatch) {
    dispatch({
        type: AUTH.SIGNIN_USER
    })
    return apiPromise
        .then((response) => {
            response?.data && dispatch(signInSuccess(response.data))
        })
        .catch((error) => {
            dispatch(signInFail(error?.response?.data || error))
        })
}

export const signIn = (payload) => {
    return (dispatch) => signInHandler(Api.signIn(payload.values), dispatch)
}

export const signInSuccess = (payload) => (dispatch) => {
    EventEmitter.emit(Events.Login, payload)

    dispatch({
        type: AUTH.SIGNIN_USER_SUCCESS,
        payload
    })
}

export const signInFail = (payload) => ({
    type: AUTH.SIGNIN_USER_FAIL,
    payload
})

export const signInWithTokenLink = (payload) => (dispatch) => {
    return signInHandler(Api.signInToken(payload), dispatch)
}

export const signOutWithSip = () => (dispatch) => {
    Webphone.unregister()
    dispatch(signOut())
}

export const signOut = () => (dispatch) => {
    dispatch({
        type: AUTH.SIGNOUT_USER
    })
    return Api.logout()
        .then(() => dispatch(signOutSuccess()))
        .catch(() => dispatch(signOutFailed()))
}

export const signOutSuccess = () => (dispatch) => {
    EventEmitter.emit(Events.Logout, { success: true })
    Cookies.remove(TabIdCookieName)

    dispatch({
        type: AUTH.SIGNOUT_USER_SUCCESS
    })
}

export const signOutFailed = () => (dispatch) => {
    EventEmitter.emit(Events.Logout, { success: false })

    dispatch({
        type: AUTH.SIGNOUT_USER_FAIL
    })
}

export const clearAuthAlert = () => ({
    type: AUTH.CLEAR_ALERT
})
